import { render, staticRenderFns } from "./importantList-add-or-update.vue?vue&type=template&id=812bdf2c&scoped=true"
import script from "./importantList-add-or-update.vue?vue&type=script&lang=js"
export * from "./importantList-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./importantList-add-or-update.vue?vue&type=style&index=0&id=812bdf2c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812bdf2c",
  null
  
)

export default component.exports